import { Box } from '@razorpay/blade/components';
import MultiSelect from 'components/ui/Dropdown/MultiSelect';
import React from 'react';

interface ColumnSelectorProps {
  options: { key: string; label: string }[];
  selectedKeys: string[];
  onChange: (keys: string[]) => void;
}

const ColumnSelector = ({ options, selectedKeys, onChange }: ColumnSelectorProps) => {
  const multiSelectOptions = options.map((opt) => ({
    key: opt.key,
    value: opt.label,
  }));

  return (
    <Box width="242px">
      <MultiSelect
        id="custom-report-column-selector"
        options={multiSelectOptions}
        name="Employee Data"
        value={selectedKeys}
        onChange={onChange}
        disableChipsDisplay={false}
        disableAllOption={false}
      />
    </Box>
  );
};

export default ColumnSelector;
